export const apiMethodsConst = Object.freeze({
  SIGN_IN_REQUEST: 'signInRequest',
  AUTH_ME_REQUEST: 'authMeRequest',
  USER_CREDENTIALS_REQUEST: 'userCredentialsRequest',
  AUTH_SIGN_UP_REQUEST: 'authSignUpRequest',
  AUTH_LOGOUT_REQUEST: 'authLogoutRequest',
  EDIT_USER_REQUEST: 'editUserRequest',
  ADD_ADDRESS_REQUEST: 'addAddressRequest',
  ADD_OFFICE_PRODUCTIVITY_REQUEST: 'addOfficeProductivityRequest',
  BLOCK_PROFESSIONAL_REQUEST: 'blockProfessionalRequest',
  PHONE_VERIFICATION_REQUEST: 'phoneVerificationRequest',
  SEND_SMS_CODE_REQUEST: 'sendSMSCodeRequest',
  DELETE_ADDRESSES_REQUEST: 'deleteAddressesRequest',
  AUTH_REFRESH_REQUEST: 'authRefreshRequest',
  FEEDBACK_REQUEST: 'feedbackRequest',
  FEEDBACK_SAVE_REQUEST: 'feedbackSaveRequest',
  SEND_PROCEDURE_ENDORSEMENT_REQUEST: 'sendProcedureEndorsementRequest',
  FETCH_USER_PROCEDURE_ENDORSEMENT_REQUEST: 'fetchUserProcedureEndorsementRequest',
  SEND_NPS_REQUEST: 'saveNpsRequest',
  SEND_TEMPMEE_FEEDBACK_REQUEST: 'saveTempMeeFeedbackRequest',
  GET_ALL_PROFESSIONS_REQUEST: 'getAllProfessionsRequest',
  GET_ALL_SPECIALIZATIONS_REQUEST: 'getAllSpecializationsRequest',
  GET_USER_EDUCATION_REQUEST: 'getUserEducationRequest',
  GET_OFFICE_EDUCATION_REQUEST: 'getOfficeEducationRequest',
  UPDATE_USER_EDUCATION_REQUEST: 'updateUserEducationRequest',
  GET_ALL_SOFTWARES_REQUEST: 'getAllSoftwaresRequest',
  ACCEPT_TERMS_REQUEST: 'acceptTermsRequest',
  GET_TERMS_AND_CONDITIONS_FOR_STAFF_REQUEST: 'getTermsAndConditionsForStaffRequest',
  ACCEPT_TERMS_AND_CONDITIONS_FOR_STAFF_REQUEST: 'acceptTermsAndConditionsForStaffRequest',
  ACCEPT_PSA_TERMS_REQUEST: 'acceptPSATermsRequest',
  UPLOAD_AVATAR_REQUEST: 'uploadAvatarRequest',

  FORGOT_PASSWORD_REQUEST: {
    SEND_CODE: 'forgotPasswordSendCodeRequest',
    RESET: 'forgotPasswordResetRequest',
  },

  CLOSE_MODAL_ACTION: 'CLOSE_MODAL_ACTION_SUCCESS',
  // dso
  GET_SELECTED_OFFICE_PROFILE_REQUEST: 'getSelectedOfficeProfile',
  GET_DSO_OFFICE_BY_ID_REQUEST: 'getDSOOfficeByIdRequest',

  REQUEST_PAYMENT_REPORT: 'requestPaymentReport',
  // job
  FETCH_JOB_REQUEST: 'fetchJobRequest',
  FETCH_CANDIDATE_OVERTIME_REQUEST: 'fetchCandidateOvertimeRequest',
  GET_USER_OVERTIME_LIMITS_REQUEST: 'getUserOvertimeLimitsRequest',
  FETCH_AVERAGE_RATING: 'fetchAverageRatingRequest',
  EDIT_JOB_REQUEST: 'editJobRequest',
  FETCH_OPEN_JOB_REQUEST: 'fetchOpenJobRequest',
  FETCH_SCHEDULED_JOBS_REQUEST: 'fetchScheduledJobsRequest',
  FETCH_ACTION_REQUIRED_JOBS_REQUEST: 'fetchActionRequiredJobsRequest',
  FETCH_TODAY_JOBS_REQUEST: 'fetchTodayJobsRequest',
  GET_ALL_JOBS_REQUEST: 'getAllJobsRequest',
  GET_JOBS_BY_STATUS_DATE_REQUEST: 'getJobsRequestByStatusDate',
  FETCH_JOBS_WITH_TRANSACTIONS: 'fetchJobsWithTransactions',
  CANCEL_JOB_REQUEST: 'cancelJobRequest',
  CONFIRM_JOB_REQUEST: 'confirmJobRequest',
  REPORT_INCIDENT_REQUEST: 'reportIncidentRequest',
  MULTIDAY_JOB_POSTING_REQUEST: 'multidayJobPostingRequest',
  PP_POSTING_REQUEST: 'ppbPostingRequest',
  DECLINE_COUNTER_OFFER_REQUEST: 'declineCounterOffer',
  FETCH_EXPIRED_COUNTER_OFFERS: 'fetchExpiredCounterOffersRequest',
  ADJUST_HOURS_REQUEST: 'adjustHoursRequest',
  FETCH_CANCELLATION_REASONS_REQUEST: 'fetchCancellationReasonsRequest',
  SET_CANCELLATION_REASONS_REQUEST: 'setCancellationReasonsRequest',
  GET_JOBS_REQUEST: 'getJobsRequest',

  // receipts
  FETCH_RECEIPTS_REQUEST: 'fetchReceiptsRequest',
  FETCH_RECEIPTS_REPORT_REQUEST: 'fetchReceiptsReportRequest',
  FETCH_RECEIPTS_V2_REQUEST: 'fetchReceiptsV2Request',
  FETCH_RECEIPTS_CSV_REPORT_V2_REQUEST: 'fetchReceiptsCSVReportV2Request',
  // invoices
  FETCH_INVOICES_REQUEST: 'fetchInvoicesRequest',

  // pp
  FETCH_ALL_PP_JOBS: 'fetchAllPPJobsRequest',
  FETCH_PP_APPLICATIONS_REQUEST: 'fetchPPApplicationsRequest',
  POST_PP_ACTIONS_REQUEST: 'postPPActionnRequest',
  FETCH_PP_APPLICATION_BY_ID_REQUEST: 'fetchPPApplicationByIdRequest',

  // adjustments
  FETCH_JOBS_WITH_ADJUSTMENTS_REQUEST: 'fetchAdjustmentsRequest',
  CHANGE_STATUS_ADJUSTMENTS_REQUEST: 'changeStatusAdjustmentsRequest',

  // locum tenens dentist
  CREATE_LOCUM_TENENS_DENTIST_REQUEST: 'createLocumTenensDentistRequest',

  // notifications
  FETCH_NOTIFICATION_SETTINGS_REQUEST: 'fetchNotificationSettingsRequest',
  UPDATE_NOTIFICATION_SETTINGS_REQUEST: 'updateNotificationSettingsRequest',

  // favorites
  FETCH_FAVORITE_PROFESSIONALS_REQUEST: 'fetchFavoritesProfessionalRequest',
  DELETE_FAVORITE_PROFESSIONAL_REQUEST: 'deleteFavoriteProfessionalRequest',
  ADD_FAVORITE_PROFESSIONAL_REQUEST: 'addFavoriteProfessionalRequest',
  INVITE_FAVORITE_TO_JOB_REQUEST: 'inviteFavoriteToJobRequest',
  INVITE_PROFESSIONALS_TO_JOBS_REQUEST: 'inviteProfessionalsToJobsRequest',

  // recent professionals
  FETCH_RECENT_PROFESSIONALS_REQUEST: 'fetchRecentProfessionalsRequest',
  FETCH_OPEN_JOBS_FOR_RECENT_PROFESSIONAL_REQUEST: 'fetchOpenJobsForRecentProfessionalRequest',

  // recommended professionals
  FETCH_RECOMMENDED_PROFESSIONALS_REQUEST: 'fetchRecommendedProfessionalsRequest',

  // invites
  FETCH_OFFICE_JOB_INVITES_REQUEST: 'fetchOfficeJobInvitesRequest',

  // partnership code
  FETCH_PARTNERSHIP_ORGANIZATIONS_REQUEST: 'fetchPartnershipOrganizationsRequest',
  VERIFY_PARTNERSHIP_CODE_REQUEST: 'verifyPartnershipCodeRequest',

  // metadata
  FETCH_METADATA_REQUEST: 'fetchMetadataRequest',

  // worker type
  SAVE_WORKER_CLASSIFICATION_REQUEST: 'saveWorkerClassificationRequest',
  GET_STATE_WORKER_CLASSIFICATION_REQUEST: 'getStateWorkerClassificationRequest',
  GET_WORKER_CLASSIFICATION_MANAGEMENT: 'getWorkerClassificationManagement',
  SAVE_CHILD_WORKER_CLASSIFICATION: 'saveChildOfficeWorkerClassification',
  SAVE_STATUS_CHILD_WORKER_CLASSIFICATION: 'saveStatusChildOfficeWorkerClassification',

  // Office Rating
  GET_OFFICE_REVIEW_INFO_REQUEST: 'getOfficeReviewInfoRequest',

  // Child Offices
  GET_CHILD_OFFICES_REQUEST: 'getChildOfficesRequest',

  // Professional Profile
  FETCH_PROFESSIONAL_PROFILE_REQUEST: 'fetchProfessionalProfile',
});
